import React from 'react';
import { useTranslation } from 'react-i18next';
import { Activity, Radio, Target, Cpu, Zap, DollarSign, RefreshCw, BarChart3, ChevronRight } from 'lucide-react';

const stages = [
  { id: 1, name: 'Signal Capture', icon: Radio, desc: 'Tick data, On-chain, Alt data, Sentiment' },
  { id: 2, name: 'Alpha Scoring', icon: Target, desc: 'ML scoring, Edge calc, Win rate est.' },
  { id: 3, name: 'Orchestrator', icon: Cpu, desc: 'Assign agent, Prioritize, Kelly sizing' },
  { id: 4, name: 'Execution', icon: Zap, desc: 'Smart routing, Impact min, <1ms fill' },
  { id: 5, name: 'P&L Capture', icon: DollarSign, desc: 'Tick P&L, Attribution, Fee netting' },
  { id: 6, name: 'Reinvestment', icon: RefreshCw, desc: 'Compound auto, Kelly rebalance' },
  { id: 7, name: 'Model Update', icon: BarChart3, desc: 'Online learning, RL reward, Evo' },
];

export function Pipeline() {
  const { t } = useTranslation();
  return (
    <div className="bg-[#090B0F] border border-white/10 p-4 md:p-6" data-testid="pipeline-view">
      <div className="flex items-center gap-2 mb-6">
        <Activity className="w-5 h-5 text-emerald-500" />
        <h3 className="text-sm uppercase tracking-[0.2em] font-semibold text-white">{t('dashboard.alphaPipeline')}</h3>
      </div>
      <div className="flex flex-col lg:flex-row gap-2">
        {stages.map((stage, idx) => (
          <React.Fragment key={stage.id}>
            <div className="flex-1 bg-[#11141D] border border-white/10 p-3 hover:border-white/20 transition-all"
              data-testid={`pipeline-node-${stage.name.toLowerCase().replace(/\s/g, '-')}`}>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-5 h-5 bg-emerald-500/20 flex items-center justify-center">
                  <span className="text-emerald-500 font-mono text-[10px]">{String(stage.id).padStart(2, '0')}</span>
                </div>
                <stage.icon className="w-3.5 h-3.5 text-emerald-500" />
              </div>
              <h4 className="font-semibold text-white text-xs mb-0.5">{stage.name}</h4>
              <p className="text-slate-500 text-[10px] font-mono line-clamp-2">{stage.desc}</p>
            </div>
            {idx < stages.length - 1 && (
              <div className="hidden lg:flex items-center justify-center">
                <ChevronRight className="w-3 h-3 text-slate-600" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
